import { FieldType } from '@ngx-formly/core';
import { v4 } from 'uuid';

export abstract class SbFieldComponent extends FieldType {
    getClass() {}

    /**
     * A hack to workaround the annoying autofill in chrome to
     * prevent it from autofilling (not autocomplete) based on your history.
     * It seems to carry history based on component name.
     **/
    getRandomName() {
        return v4();
    }
}
